module.exports = __webpack_public_path__ + "static/img/pc_hd_activity4_content2_img.8cdf6c4.png";